import { Config } from "../entities/config";
import {
  DEFAULT_UNREAD_MESSAGES_COUNT,
  EventActions,
  IFRAME_ID,
  LOGGED_IN_USER_NO_NAME_STATUS,
  LOGGED_OUT_USER_STATUS,
} from "../utility/constants";
import { NaviError, NaviErrorTypes } from "../utility/navi-error";
import { GlobalDataLayerService } from "./analytics/global-data-layer-service";
import windowService from "./window-service";
import { getUserInformation } from "./user-information-service";
import { finderStateStore } from "../state/finder-state-store";
import { navStateStore } from "../state/nav-state-store";
import { UserData } from "../entities/user-information";
import { IsLoggedIn, isString } from "../utility/helper";

export function getUserNameFromUserData({
  firstName,
  lastName,
}: UserData = {}): string {
  return [firstName, lastName].filter(isString).join(" ");
}

export async function initializeUserData(
  accessToken: string,
  locale: string,
): Promise<void> {
  let loggedInState = LOGGED_OUT_USER_STATUS;
  let userId: string;
  let ciamid: string;

  try {
    const bffData = await getUserInformation(accessToken, locale);

    if (bffData === undefined || bffData === null) {
      throw new NaviError(
        `Invalid user data object extracted from user profile response`,
        NaviErrorTypes.NO_RESULTS,
      );
    }

    finderStateStore.state.savedSearchesCount = bffData.savedSearches;
    finderStateStore.state.savedVehiclesCount = bffData.savedVehicles;
    navStateStore.state.unreadMessagesCount = bffData.unreadMessages;
    const { userData } = bffData;

    loggedInState =
      getUserNameFromUserData(userData) || LOGGED_IN_USER_NO_NAME_STATUS;
    userId = bffData.userData.userId ?? "";
    ciamid = bffData.userData.ciamId ?? "";
    if (loggedInState) {
      GlobalDataLayerService.getInstance().setUser(
        userId,
        ciamid,
        IsLoggedIn(loggedInState),
      );
      GlobalDataLayerService.getInstance().pushDataLayerEvent(
        EventActions.IDS_LOAD,
      );
    }
  } catch (err) {
    if (
      !(err instanceof NaviError) ||
      err.type !== NaviErrorTypes.UNAUTHORIZED
    ) {
      loggedInState = LOGGED_IN_USER_NO_NAME_STATUS;
    }

    navStateStore.state.unreadMessagesCount = DEFAULT_UNREAD_MESSAGES_COUNT;
    navStateStore.state.loggedInState = loggedInState;
    throw err;
  }

  navStateStore.state.loggedInState = loggedInState;
  GlobalDataLayerService.getInstance().setUser(
    userId,
    ciamid,
    IsLoggedIn(loggedInState),
  );
}

export function initAuthIframe(config: Config): void {
  const parameters = {
    domain: config.IDENTITY_PROVIDER_URL,
    clientId: config.IDENTITY_CLIENT_ID,
    redirect_uri: config.LOGIN_REDIRECT_URL,
    audience: config.IDENTITY_AUDIENCE,
    scope: config.IDENTITY_USER_SCOPES,
  };
  const queryString = Object.entries(parameters)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join("&");

  const { LOGIN_REDIRECT_URL } = config;
  windowService.removeElement(IFRAME_ID);
  windowService.createIframe(IFRAME_ID, `${LOGIN_REDIRECT_URL}?${queryString}`);
}
